import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { GoalService } from '../services/goal.service';
import { forkJoin, map, Observable, switchMap } from 'rxjs';
import { StrategyService } from '../services/strategy.service';
import { Goal } from '../interfaces/models/goal.model';
import { Strategy } from '../interfaces/models/strategy.model';

export const strategicGoalsResolver: ResolveFn<Observable<{ strategy: any, goals: Goal[], strategies: Strategy[] }>> = (route, state) => {
  const goalsService = inject(GoalService);
  const strategyService = inject(StrategyService);
  const strategyId = route.params['strategyId'];
  if (!+strategyId) {
    return strategyService.defaultStrategy$.pipe(

      switchMap((strategy: any) => {
        return forkJoin({
          goalsResponse: goalsService.getListGoals(strategy.id),
          strategies: strategyService.RawStrategies$
        }).pipe(
          map(({ goalsResponse, strategies }) => {
            return {
              strategy,
              goals: goalsResponse.goals,
              strategies
            };
          })
        );
      }));
  } else {
    return forkJoin({
      strategy: strategyService.getStrategyById(strategyId),
      goalsResponse: goalsService.getListGoals(strategyId),
      strategies: strategyService.RawStrategies$
    }).pipe(
      map(({ strategy, goalsResponse, strategies }) => ({
        strategy,
        goals: goalsResponse.goals,
        strategies
      }))
    )
  }
}